// extracted by css-extract-rspack-plugin
export default {"root":"root-1-JSJ","smallMenu":"smallMenu-2lr1K","badge":"badge-1xKcc","menuBadgeContainer":"menuBadgeContainer-22Rh6"};